import axiosInstance from '../axiosInterceptor/axiosInstance'

const assignTeamToGroup = async ({ orgId, groupId, seasonTeamId }) => {
  const url = `v1/orgs/${orgId}/season-teams/${seasonTeamId}/assign-group`
  const response = await axiosInstance.post(url, {groupId})
  return response?.data
}

export default assignTeamToGroup
